/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React, { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ERROR_SCREEN_TYPES } from '../../Screens/DxpErrorScreen/DxpErrorScreen.constants';

/**
 * DXP Console 404 Screen.
 * @export
 * @returns {JSX.Element} The `<Dxp404 />` component.
 */
export const Dxp404 = (): JSX.Element => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  // Set up redirects so we can safely move
  // to US language in the URL
  const redirectHandler = useCallback((): void => {
    let redirectPath = ``;
    let redirectSearch = ``;

    // Check for landing screen
    // Then check for org screen
    // Otherwise redirect to error
    if (pathname.indexOf(`/organisations`) === 0) {
      redirectPath = `/organizations`;
    } else if (pathname.indexOf(`/organisation/`) === 0) {
      redirectPath = pathname.replace(/organisation/g, `organization`);
    } else {
      redirectPath = `/error`;
      redirectSearch = `?type=${ERROR_SCREEN_TYPES.noPageAccessError}`;
    }

    navigate({ pathname: redirectPath, search: redirectSearch });
  }, [navigate, pathname]);

  useEffect(() => {
    redirectHandler();
  }, [redirectHandler]);

  return <></>;
};
